import { DimTree } from '@/common/entityFramework/entityPerspective/support/DimTree';
import { useForm } from '@/common/form/FormContext';
import { TreeUtils } from '@/common/utils/TreeUtils';
import { Box } from '@mui/material';
import { DemGtnSummaryModeToggle } from './DemGtnSummaryModeToggle';

export const DemGtnSummaryFilters = ({ prodDim, periodDim }) => {
  const { formValues, assignValue } = useForm();

  // An unfiltered dim shows everything as selected
  const { leafIds: prodLeafIds } = TreeUtils.parseTree(prodDim.tree);
  const { leafIds: periodLeafIds } = TreeUtils.parseTree(periodDim.tree);

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Box sx={{ width: 220 }}>
        <DimTree
          size="small"
          displayName={prodDim.displayName}
          treeData={prodDim.tree}
          selectedIds={formValues.prodIds ?? prodLeafIds}
          onFilterChange={(ids) => assignValue('prodIds', ids)}
        />
      </Box>
      <Box sx={{ width: 220 }}>
        <DimTree
          size="small"
          displayName={periodDim.displayName}
          treeData={periodDim.tree}
          selectedIds={formValues.periodIds ?? periodLeafIds}
          onFilterChange={(ids) => assignValue('periodIds', ids)}
        />
      </Box>
      <DemGtnSummaryModeToggle />
    </Box>
  );
};
